module.exports = __webpack_public_path__ + "img/AI_17.a4c75d18.png";